import React from 'react'
import './App.css';
import Navbar from "./components/Navbar/Navbar"
import Header from "./components/Header/Header"
import Services from "./components/Services/Services"
import Portfolio from "./components/Portfolio/Portfolio"
import Clients from "./components/Clients/Clients"
import Testimonials from "./components/Testiomonials/Testimonials"
import Blog from "./components/Blog/Blog"
import Contact from "./containers/Contact/Contact"
import Footer from "./containers/Footer/Footer"



function App() {
  return (
    <div>
      <Navbar />
      <Header />
      <Services />
      <Portfolio />
      <Clients />
      <Testimonials />
      <Blog />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
